// Handbag clearance buy box (sections/skullette-handbag-clearance.liquid). One box, four parts:
//   1) the cell = size × leather (mv medium faux · sv small faux · mt medium top-grain · st small top-grain), one price
//      each = data-cells, which MUST equal the Function gate handbag-clear (set_totals + variant_totals);
//   2) the print: designs grouped across products (each interior and the Small twin are separate products). A design
//      shows in a cell when at least one interior has that cell's variant in the pool; with two or more interiors in
//      stock for the cell, the tile and the sheet show an interior picker;
//   3) the FREE long wallet; 4) the FREE mini wallet.
// The page never prints a number the cart will not: the bag pays min(cell price, set list) exactly like the Function.
const root = document.querySelector('[data-skc][data-skc-kind="bag"]');
if (root && window.fetch) {
  const core = await import(root.getAttribute('data-skc-core'));
  init(core);
}

function init({ money, fill, esc, decodeEntities, readJson, scrollToEl, addSetToCart, paintDeadline, renderTabs, createSheet, paintSheetGallery, wireSticky, MOBILE_MAX }) {
  const C = readJson(root, '[data-skc-copy]', {});
  const bagRows = readJson(root, '[data-skc-pool="bag"]', []);
  const pools = { wallet: readJson(root, '[data-skc-pool="wallet"]', []), mini: readJson(root, '[data-skc-pool="mini"]', []) };
  let CELLS = {};
  try {
    CELLS = JSON.parse(root.getAttribute('data-cells') || '{}');
  } catch (error) {
    console.error('[skc] cells_json is not JSON', error);
  }
  if (!bagRows.length || !pools.wallet.length || !pools.mini.length || !Object.keys(CELLS).length) {
    console.error('[skc] handbag clearance: empty pool or cells; buy box disabled');
    return;
  }
  const KINDS = ['bag', 'wallet', 'mini'];
  const KIND_LABEL = { bag: C.kind_bag || 'print', wallet: C.kind_wallet || 'long wallet', mini: C.kind_mini || 'mini wallet' };
  const PAGE = 8;
  const EL = 'x-hbc';

  // ---- designs: group products by design name; per cell, the in-pool options (one per interior) ----
  const cellOf = (row, leather) => (row.z === 's' ? 's' : 'm') + (leather === 't' ? 't' : 'v');
  const designs = [];
  const byName = new Map();
  bagRows.forEach((row) => {
    let d = byName.get(row.d);
    if (!d) {
      d = { key: row.d.toLowerCase().replace(/[^a-z0-9]+/g, '-'), n: row.d, s: row.s, cells: { mv: [], sv: [], mt: [], st: [] } };
      byName.set(row.d, d);
      designs.push(d);
    }
    [['f', 'v'], ['t', 't']].forEach(([field, leather]) => {
      const v = row[field];
      if (!v) return;
      const list = d.cells[cellOf(row, leather)];
      if (!list.some((o) => o.i === row.i)) list.push({ i: row.i, id: v.id, p: v.p, row });
    });
  });
  const CELL_ORDER = ['mv', 'sv', 'mt', 'st'].filter((c) => CELLS[c] && designs.some((d) => d.cells[c].length));
  if (!CELL_ORDER.length) {
    console.error('[skc] handbag clearance: no cell in cells_json has a design in stock; buy box disabled');
    return;
  }
  const cellSpec = (c) => {
    const d = designs.find((x) => x.cells[c].length);
    return d ? d.cells[c][0].row : null;
  };
  const cellList = (c) => (designs.find((x) => x.cells[c].length)?.cells[c][0].p) || 0;

  // ---- tabs (style registers) ----
  const TABS = (root.getAttribute('data-tabs') || '').split('|').map((x) => x.split('=')).filter((x) => x[0] && x[1]).map(([key, label]) => ({ key: key.trim(), label: label.trim() }));
  const tabsFor = (items) => {
    const have = new Set(items.map((x) => x.s));
    const out = TABS.filter((t) => have.has(t.key));
    if ([...have].some((s) => !TABS.some((t) => t.key === s))) out.push({ key: 'other', label: C.tab_other || 'More' });
    return out;
  };
  const inTab = (item, tab) => (tab === 'other' ? !TABS.some((t) => t.key === item.s) : item.s === tab);

  const st = {
    cell: CELL_ORDER[0],
    picks: { bag: null, wallet: null, mini: null }, // bag = { d, i }
    interior: {}, // design key → interior shown on its tile before it is picked
    tab: {},
    shown: { bag: PAGE, wallet: PAGE, mini: PAGE },
    busy: false,
  };
  const $ = (sel) => root.querySelector(sel);
  const $$ = (sel) => root.querySelectorAll(sel);
  const setText = (sel, txt) => $$(sel).forEach((el) => (el.textContent = txt));

  const optsOf = (d) => d.cells[st.cell] || [];
  const optOf = (d) => {
    const opts = optsOf(d);
    const want = st.picks.bag && st.picks.bag.d === d ? st.picks.bag.i : st.interior[d.key];
    return opts.find((o) => o.i === want) || opts[0] || null;
  };
  const pickedOpt = () => (st.picks.bag ? optOf(st.picks.bag.d) : null);
  const itemsOf = (k) => (k === 'bag' ? designs.filter((d) => optsOf(d).length) : pools[k]);
  const tabOf = (k) => {
    const tabs = tabsFor(itemsOf(k));
    if (!tabs.some((t) => t.key === st.tab[k])) st.tab[k] = tabs[0]?.key;
    return st.tab[k];
  };
  const listOf = (k) => itemsOf(k).filter((x) => inTab(x, tabOf(k)));
  const missing = () => KINDS.filter((k) => !st.picks[k]);
  const ready = () => !missing().length;

  // ad hand-off (#745): snippets/skullette-ad-design-hero read the URL and tagged the root with the design the ad showed
  // (+ its variant when the link carried one). Pre-pick it: its cell, its interior, its style tab, and keep it on screen.
  (function prepick() {
    const key = root.getAttribute('data-sk-ad-design');
    const d = key && designs.find((x) => x.key === key);
    if (!d) return;
    const vid = Number(root.getAttribute('data-sk-ad-variant')) || 0;
    const cell = CELL_ORDER.find((c) => d.cells[c].some((o) => Number(o.id) === vid)) || CELL_ORDER.find((c) => d.cells[c].length);
    if (!cell) return;
    st.cell = cell;
    const o = d.cells[cell].find((x) => Number(x.id) === vid) || d.cells[cell][0];
    st.interior[d.key] = o.i;
    st.picks.bag = { d, i: o.i };
    st.tab.bag = TABS.some((t) => t.key === d.s) ? d.s : 'other';
    const at = listOf('bag').indexOf(d);
    if (at >= st.shown.bag) st.shown.bag = at + 1;
  })();

  function pricing() {
    const opt = pickedOpt();
    const bagList = opt ? opt.p : cellList(st.cell);
    const value = bagList + (st.picks.wallet ? st.picks.wallet.v.p : pools.wallet[0].v.p) + (st.picks.mini ? st.picks.mini.v.p : pools.mini[0].v.p);
    // the Function never charges more than the set's list price
    const pay = Math.min(CELLS[st.cell] || value, value);
    return { value, pay, bagList };
  }
  const shortSize = (row) => (row?.sz || '').split(' (')[0];

  function renderCells() {
    const box = $('[data-skc-cells]');
    box.innerHTML = '';
    CELL_ORDER.forEach((c) => {
      const on = c === st.cell;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'skc__tier';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(on));
      b.setAttribute('data-hc-el', `${EL}-cell-${c}`);
      const apart = cellList(c) + pools.wallet[0].v.p + pools.mini[0].v.p;
      b.innerHTML = `<span class="rad" aria-hidden="true"></span><span class="txt"><b>${esc(C.cell_labels?.[c] || c)}</b><small>${esc(fill(C.cell_sub, { size: shortSize(cellSpec(c)) }))}</small></span><span class="pr"><span class="p">${money(CELLS[c])}</span><i>${esc(fill(C.card_was, { value: money(apart) }))}</i></span>`;
      b.addEventListener('click', () => {
        if (st.cell === c) return;
        st.cell = c;
        if (st.picks.bag && !optsOf(st.picks.bag.d).length) st.picks.bag = null;
        st.shown.bag = PAGE;
        render();
      });
      box.appendChild(b);
    });
  }

  const imgOf = (k, item) => (k === 'bag' ? optOf(item)?.row.img : item.img);
  function renderSlots(pr) {
    const box = $('[data-skc-slots]');
    box.innerHTML = '';
    KINDS.forEach((k) => {
      const p = st.picks[k];
      const item = k === 'bag' && p ? p.d : p;
      const paid = k === 'bag';
      const el = document.createElement(p ? 'button' : 'span');
      if (p) {
        el.type = 'button';
        el.setAttribute('aria-label', `Remove ${item.n}`);
        el.setAttribute('data-hc-el', `${EL}-slot-remove`);
        el.addEventListener('click', () => {
          st.picks[k] = null;
          render();
        });
      }
      el.className = `skc__slot${p ? ' is-filled' : ''}${paid ? ' is-paid' : ' is-free'} skc__slot--${k}`;
      const tag = paid ? (p ? money(pr.pay) : C.slot_pay) : C.slot_free;
      el.innerHTML = (p ? `<span class="im"><img src="${esc(imgOf(k, item))}" alt=""></span><span class="x" aria-hidden="true">×</span>` : `<span class="im is-empty">${esc(C['slot_' + k] || '')}</span>`) + `<span class="tag">${esc(tag || '')}</span>`;
      box.appendChild(el);
    });
  }

  function interiorPicker(d, cls) {
    const opts = optsOf(d);
    if (opts.length < 2) return null;
    const cur = optOf(d);
    const wrap = document.createElement('div');
    wrap.className = 'skc__int' + (cls ? ' ' + cls : '');
    wrap.setAttribute('role', 'radiogroup');
    wrap.setAttribute('aria-label', `${C.interior_label || 'Interior'}: ${d.n}`);
    wrap.innerHTML = `<span class="skc__int-l">${esc(C.interior_label || 'Interior')}</span>`;
    opts.forEach((o) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(o === cur));
      b.setAttribute('data-hc-el', `${EL}-interior`);
      b.textContent = o.i || '·';
      b.addEventListener('click', () => {
        st.interior[d.key] = o.i;
        if (st.picks.bag && st.picks.bag.d === d) st.picks.bag.i = o.i;
        render();
      });
      wrap.appendChild(b);
    });
    return wrap;
  }

  function tile(k, item) {
    const isBag = k === 'bag';
    const on = isBag ? st.picks.bag?.d === item : st.picks[k] === item;
    const t = document.createElement('div');
    t.className = 'skc__tile' + (on ? ' is-picked' : '');
    let line;
    if (isBag) {
      const o = optOf(item);
      line = fill(esc(C.tile_bag), { list: money(o.p), pay: `<b>${money(Math.min(CELLS[st.cell], o.p + pools.wallet[0].v.p + pools.mini[0].v.p))}</b>` });
    } else line = fill(esc(C.tile_free), { list: money(item.v.p) });
    const btn = on ? (isBag ? C.picked_bag : fill(C.picked_free, { k: KIND_LABEL[k] })) : isBag ? C.pick_bag : fill(C.pick_free, { k: KIND_LABEL[k] });
    t.innerHTML = `<button type="button" class="skc__tile-view" data-hc-el="${EL}-tile-view" aria-label="${esc(C.view_details)}: ${esc(item.n || item.d)}"><span class="im"><img src="${esc(imgOf(k, item))}" alt="" loading="lazy" width="700" height="933"></span></button><div class="skc__tile-body"><span class="n">${esc(item.n || item.d)}</span><span class="f">${line}</span></div><div class="skc__tile-int"></div><button type="button" class="skc__tile-link" data-hc-el="${EL}-tile-view">${esc(C.view_details)}</button><div class="skc__stepper"><button type="button" class="add${on ? ' is-chosen' : ''}" aria-pressed="${on}" data-hc-el="${EL}-pick-${k}">${esc(btn)}</button></div>`;
    if (isBag) {
      const ip = interiorPicker(item);
      if (ip) t.querySelector('.skc__tile-int').appendChild(ip);
    }
    t.querySelectorAll('.skc__tile-view, .skc__tile-link').forEach((b) => b.addEventListener('click', () => openSheet(k, item)));
    t.querySelector('.add').addEventListener('click', () => pick(k, item));
    return t;
  }

  function renderPart(k) {
    const items = itemsOf(k);
    renderTabs($(`[data-skc-tabs="${k}"]`), tabsFor(items), tabOf(k), EL, (key) => {
      st.tab[k] = key;
      st.shown[k] = PAGE;
      render();
    });
    const grid = $(`[data-skc-grid="${k}"]`);
    const more = $(`[data-skc-more="${k}"]`);
    const list = listOf(k);
    grid.innerHTML = '';
    list.slice(0, st.shown[k]).forEach((item) => grid.appendChild(tile(k, item)));
    const left = list.length - st.shown[k];
    more.hidden = left <= 0;
    if (left > 0) more.textContent = fill(C.show_more, { n: left });
    const p = st.picks[k];
    setText(`[data-skc-count="${k}"]`, p ? `${(k === 'bag' ? p.d.n : p.d)} ✓` : C.count_pick || '');
  }

  function pick(k, item) {
    if (k === 'bag') st.picks.bag = { d: item, i: optOf(item)?.i };
    else st.picks[k] = item;
    render();
    const next = missing()[0];
    if (next && window.innerWidth < MOBILE_MAX) scrollToEl($(`[data-skc-part="${next}"]`));
  }

  const ctaText = () => {
    const m = missing();
    return m.length ? fill(C.cta_pick, { k: KIND_LABEL[m[0]] }) : C.cta_add;
  };
  const cta = $('[data-skc-cta]');
  const ctaLabel = $('[data-skc-cta-label]');
  const ctaPrice = $('[data-skc-cta-price]');
  const err = $('[data-skc-error]');
  const stBtn = $('[data-skc-sticky-btn]');

  function render() {
    const pr = pricing();
    const done = ready();
    renderCells();
    renderSlots(pr);
    KINDS.forEach(renderPart);
    setText('[data-skc-was]', fill(C.card_was, { value: money(pr.value) }));
    setText('[data-skc-sum-was]', money(pr.value));
    setText('[data-skc-price]', money(pr.pay));
    setText('[data-skc-sum-pay]', money(pr.pay));
    setText('[data-skc-chip]', C.chip_save && pr.value - pr.pay > 0.004 ? fill(C.chip_save, { amount: money(pr.value - pr.pay) }) : '');
    setText('[data-skc-sum-label]', fill(C.sum_label, { cell: C.cell_labels?.[st.cell] || '' }));
    if (!st.busy) {
      cta.disabled = !done;
      ctaLabel.textContent = ctaText();
      ctaPrice.textContent = done ? money(pr.pay) : '';
      stBtn.textContent = done ? C.cta_add : ctaText() + ' ↑';
    }
    setText('[data-skc-sticky-price]', money(pr.pay));
    setText('[data-skc-sticky-sub]', fill(C.sticky_sub, { n: KINDS.length - missing().length }));
    if (sheet.state.open) fillSheetState();
    sticky?.refresh();
  }

  // ---- detail sheet ----
  const sheet = createSheet(root);
  let sheetItem = null;
  function openSheet(k, item) {
    sheetItem = { k, item };
    paintSheet();
    sheet.open();
  }
  function paintSheet() {
    const { k, item } = sheetItem;
    const isBag = k === 'bag';
    const row = isBag ? optOf(item)?.row : item;
    paintSheetGallery(sheet, row.imgs?.length ? row.imgs : [row.img], item.n || item.d);
    const cellLabel = C.cell_labels?.[st.cell] || '';
    sheet.q('[data-skc-sheet-title]').textContent = isBag ? `${item.n} · ${cellLabel.split(' · ')[0]}` : `${item.d} · ${KIND_LABEL[k]}`;
    const stEl = sheet.q('[data-skc-sheet-statement]');
    stEl.hidden = true;
    const note = sheet.q('[data-skc-sheet-note]');
    note.textContent = decodeEntities(row.note);
    note.hidden = !row.note;
    let facts;
    if (isBag) {
      const o = optOf(item);
      const pay = Math.min(CELLS[st.cell], o.p + pools.wallet[0].v.p + pools.mini[0].v.p);
      facts = [[C.fact_size, row.sz], [C.fact_holds, row.fits], [C.fact_leather, cellLabel.split(' · ')[1] || '']];
      if (o.i) facts.push([C.fact_interior, o.i]);
      facts.push([C.fact_sold_apart, money(o.p)], [C.fact_on_page, fill(C.fact_on_page_val, { pay: money(pay) })]);
    } else {
      facts = [[C.fact_size, row.sz], [C.fact_holds, row.fits], [C.fact_leather, C.material_wallet], [C.fact_sold_apart, fill(C.fact_free_val, { list: money(item.v.p) })]];
    }
    sheet.q('[data-skc-sheet-facts]').innerHTML = facts.filter((f) => f[0] && f[1]).map((f) => `<div><dt>${esc(f[0])}</dt><dd>${esc(f[1])}</dd></div>`).join('');
    sheet.q('[data-skc-sheet-link]').href = row.url;
    fillSheetState();
  }
  function fillSheetState() {
    if (!sheetItem) return;
    const { k, item } = sheetItem;
    const isBag = k === 'bag';
    const on = isBag ? st.picks.bag?.d === item : st.picks[k] === item;
    const eb = sheet.q('[data-skc-sheet-eyebrow]');
    eb.textContent = on ? C.sheet_in_set || '' : isBag ? '' : C.sheet_free || '';
    eb.hidden = !eb.textContent;
    const box = sheet.q('[data-skc-sheet-actions]');
    box.innerHTML = '';
    if (isBag) {
      const ip = interiorPicker(item, 'is-big');
      if (ip) {
        // a sheet interior switch repaints the gallery too
        ip.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => paintSheet()));
        box.appendChild(ip);
      }
    }
    const wrap = document.createElement('div');
    wrap.className = 'skc__stepper is-big';
    const label = on ? (isBag ? C.picked_bag : fill(C.picked_free, { k: KIND_LABEL[k] })) : isBag ? C.pick_bag : fill(C.pick_free, { k: KIND_LABEL[k] });
    wrap.innerHTML = `<button type="button" class="add${on ? ' is-chosen' : ''}" data-hc-el="${EL}-pick-${k}">${esc(label)}</button>`;
    wrap.querySelector('.add').addEventListener('click', () => {
      if (isBag) st.picks.bag = { d: item, i: optOf(item)?.i };
      else st.picks[k] = item;
      sheet.close();
      render();
      const next = missing()[0];
      if (next) scrollToEl($(`[data-skc-part="${next}"]`));
    });
    box.appendChild(wrap);
  }

  // ---- cart ----
  const setState = (state) => {
    const txt = state === 'busy' ? C.cta_busy : state === 'added' ? C.cta_added : C.cta_add;
    ctaLabel.textContent = txt;
    stBtn.textContent = txt;
    cta.classList.toggle('is-added', state === 'added');
    cta.disabled = state !== '';
    stBtn.disabled = state !== '';
  };
  async function add() {
    if (st.busy || !ready()) return;
    st.busy = true;
    setState('busy');
    err.hidden = true;
    const items = [{ id: Number(pickedOpt().id), quantity: 1 }, { id: Number(st.picks.wallet.v.id), quantity: 1 }, { id: Number(st.picks.mini.v.id), quantity: 1 }];
    try {
      await addSetToCart(items, { key: root.getAttribute('data-key'), setName: root.getAttribute('data-set-name'), source: root.getAttribute('data-source') });
      setState('added');
      setTimeout(() => {
        st.busy = false;
        setState('');
        render();
      }, 1800);
    } catch (error) {
      console.error('[skc] handbag set add failed', error);
      st.busy = false;
      setState('');
      render();
      err.textContent = C.error || '';
      err.hidden = false;
    }
  }

  $$('[data-skc-more]').forEach((b) =>
    b.addEventListener('click', () => {
      const k = b.getAttribute('data-skc-more');
      st.shown[k] += PAGE * 2;
      render();
    })
  );
  cta.addEventListener('click', add);
  stBtn.addEventListener('click', () => {
    if (ready()) add();
    else scrollToEl($(`[data-skc-part="${missing()[0]}"]`) || $('[data-skc-cells]'));
  });
  $('[data-skc-back]')?.addEventListener('click', () => scrollToEl($('[data-skc-bb]')));

  paintDeadline(root, C);
  const sticky = wireSticky(root, { cta, isSheetOpen: () => sheet.state.open });
  render();
}
